/**
 * What the business is called on screen.
 *
 * One constant rather than the string scattered across a header, a login page
 * and a document title — those drift, and a half-renamed product looks broken.
 *
 * This is deliberately separate from the domain. The site is served from
 * parktle.com and the session cookie, localStorage keys and repository names
 * all still say parktle; those are infrastructure identifiers, and renaming
 * them would sign every user out and discard their saved vehicle profile to no
 * visible benefit.
 */
export const BRAND_NAME = 'Merritt Island';

/** Used where the name has to stand alone, with no surrounding context. */
export const BRAND_FULL = 'Merritt Island RV Parking';

/**
 * Where the business is, for anything that needs a starting point on a map.
 *
 * The search viewport used to default to Austin, Texas — a leftover from an
 * earlier build — which put the map a thousand miles from the only facility
 * and made the public search report "0 facilities in this area" to everyone
 * who did not think to pan. It lives here rather than in the store because it
 * is the same kind of fact as the name: where this business actually is.
 */
export const HOME_LOCATION = {
  lat: 28.3544,
  lng: -80.6931,
  // Wide enough to show the yard with the surrounding towns, so a visitor
  // can tell where it is without panning.
  zoom: 9,
};
